import { ErrorAPI } from "app/shared/services/api-path";
import { RESPONSEDATA } from "app/shared/services/services-model.type";
import {
  SET_STATEMENT,
  SET_STATEMENT_RESET,
  FETCH_STATEMENT_BACKUP_REQUEST,
  FETCH_STATEMENT_BACKUP_SUCCESS,
  FETCH_STATEMENT_BACKUP_FAILURE,
  FETCH_STATEMENT_V2_REQUEST,
  FETCH_STATEMENT_V2_SUCCESS,
  FETCH_STATEMENT_V2_FAILURE,
  FETCH_STATEMENT_DETAIL_REQUEST,
  FETCH_STATEMENT_DETAIL_SUCCESS,
  FETCH_STATEMENT_DETAIL_FAILURE,
  RESET_STATEMENT_BACKUP,
} from "./actions.type";
import {
  FetchStatementBackupRequest,
  FetchStatementBackupSuccess,
  FetchStatementBackupFailure,
  SetStatement,
  SetStatementReset,
  StatementState,
  FetchStatementV2Request,
  FetchStatementV2Success,
  FetchStatementV2Failure,
  FetchStatementDetailRequest,
  FetchStatementDetailSuccess,
  FetchStatementDetailFailure,
  FormFilterStatement,
  FormFilterStatementDetail,
  ResetStatementBackup,
} from "./types";

export const setStatement = (payload?: StatementState): SetStatement => ({
  type: SET_STATEMENT,
  payload,
});

export const fetchStatementBackupRequest = (payload?: FormFilterStatement): FetchStatementBackupRequest => ({
  type: FETCH_STATEMENT_BACKUP_REQUEST,
  payload,
});

export const fetchStatementBackupSuccess = (payload?: RESPONSEDATA): FetchStatementBackupSuccess => ({
  type: FETCH_STATEMENT_BACKUP_SUCCESS,
  payload,
});

export const fetchStatementBackupFailure = (): FetchStatementBackupFailure => ({
  type: FETCH_STATEMENT_BACKUP_FAILURE,
});

export const resetStatementBackup = (): ResetStatementBackup => ({
  type: RESET_STATEMENT_BACKUP,
});

export const fetchStatementV2Request = (payload?: FormFilterStatement): FetchStatementV2Request => ({
  type: FETCH_STATEMENT_V2_REQUEST,
  payload,
});

export const fetchStatementV2Success = (payload?: RESPONSEDATA): FetchStatementV2Success => ({
  type: FETCH_STATEMENT_V2_SUCCESS,
  payload,
});

export const fetchStatementV2Failure = (): FetchStatementV2Failure => ({
  type: FETCH_STATEMENT_V2_FAILURE,
});

export const fetchStatementDetailRequest = (payload?: FormFilterStatementDetail): FetchStatementDetailRequest => ({
  type: FETCH_STATEMENT_DETAIL_REQUEST,
  payload,
});

export const fetchStatementDetailSuccess = (payload?: RESPONSEDATA): FetchStatementDetailSuccess => ({
  type: FETCH_STATEMENT_DETAIL_SUCCESS,
  payload,
});

export const fetchStatementDetailFailure = (error?: ErrorAPI): FetchStatementDetailFailure => ({
  type: FETCH_STATEMENT_DETAIL_FAILURE,
  error,
});

export const setStatementReset = (): SetStatementReset => ({
  type: SET_STATEMENT_RESET,
});
